var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 15.3a4 4 0 0 0 5.4-5.5l-1 1a2.5 2.5 0 0 1-2.2 3.7c-.4 0-.8-.1-1.1-.3l-1.1 1Zm8.6-8.8c1.4 1.3 2.6 3.1 3.5 5.2v.6C20 17.2 16.1 20 12 20a9 9 0 0 1-5.3-1.7l-1.9 1.9-.5.2c-.2 0-.4 0-.5-.2a.7.7 0 0 1-.1-1L18.2 4.8v-.1l1-1c.3-.3.7-.3 1 0 .3.3.3.8 0 1l-1.8 1.8ZM8.1 12v.8l-3.5 3.6c-1-1.1-1.9-2.5-2.5-4.1v-.6C4 6.8 7.9 4 12 4c1.4 0 2.8.3 4 1L12.7 8H12a4 4 0 0 0-3.9 4Z",
    fill: "#CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.5c17031c0d13fc5fce1bd8325794afe8.svg";
export { ForwardRef as ReactComponent };